export default function eventsNav () {
  const eventsNavLinks = document.querySelectorAll('.js-events-nav a')
  const events = document.querySelectorAll('.js-event')
  const noResultsElement = document.querySelector('.js-events-no-results')

  if (noResultsElement) {
    noResultsElement.classList.add('hidden')
  }

  const showEvent = (event) => {
    event.classList.remove('hidden')
  }

  const hideEvent = (event) => {
    event.classList.add('hidden')
  }

  const showAllEvents = () => {
    events.forEach(showEvent)
  }

  const showEventsForStudio = (studioId) => {
    if (studioId === 'all') {
      showAllEvents()
    } else {
      events.forEach(event => {
        if (event.dataset.studioId === studioId) {
          showEvent(event)
        } else {
          hideEvent(event)
        }
      })
    }
  }

  const setActiveNavItem = (activeLink) => {
    eventsNavLinks.forEach((link) => {
      link.classList.remove('active')
    })
    activeLink.classList.add('active')
  }

  const updateNoResults = () => {
    const visibleEvents = document.querySelectorAll('.js-event:not(.hidden)')
    if (visibleEvents.length === 0) {
      noResultsElement.classList.add('visible')
    } else {
      noResultsElement.classList.remove('visible')
    }
  }

  const setUrlHash = (value) => {
    const url = new URL(window.location.href)
    url.hash = value || ''
    window.history.replaceState({}, '', url)
  }

  const setInitialFilter = () => {
    const url = new URL(window.location.href)
    const studioSlug = url.hash.slice(1)
    if (studioSlug) {
      const activeLink = document.querySelector(`.js-events-nav a[data-studio="${studioSlug}"]`)
      if (activeLink) {
        const studioId = activeLink.dataset.studioId
        showEventsForStudio(studioId)
        setActiveNavItem(activeLink)
      }
    }
  }

  eventsNavLinks.forEach((link) => {
    link.addEventListener('click', (ev) => {
      ev.preventDefault()
      console.log(link.dataset)
      const studioSlug = link.dataset.studio
      const studioId = link.dataset.studioId
      showEventsForStudio(studioId)
      setActiveNavItem(link)
      setUrlHash(studioSlug)
      updateNoResults()
    })
  })

  setInitialFilter()
}
